import { t } from 'ttag';

import { ConfirmActionModal, ConfirmActionModalProps } from '@ui/ConfirmActionModal';

import s from './AddPaymentCardForRozetkaDeliveryModal.sss';

type Props = Omit<
ConfirmActionModalProps,
'confirmButtonText' | 'cancelButtonText'
>;

export const AddPaymentCardForRozetkaDeliveryModal: React.FC<Props> = ({
  ...props
}) => (
  <ConfirmActionModal
    {...props}
    withClose={false}
    confirmButtonText={t`Вибрати`}
    cancelButtonText={t`Відміна`}
  >
    <p className={s.description}>
      {t`Оберіть картку або рахунок для зарахування коштів, щоб увімкнути Безпечну оплату, 
      оскільки Rozetka доступна тільки з цим способом оплати`}
    </p>
  </ConfirmActionModal>
);
